import React from "react";

export const boolToText = (bool: boolean) => {
  return bool ? 'true' : 'false';
}

export const doHighlight = (text: string, term: string) => {
  if (!term || !text) {
    return text;
  }

  const parts = text.split(new RegExp(`(${term})`, 'gi'));

  function returnHighlightText(part: string, i: number) {
    if (part.toLowerCase() === term.toLowerCase()) {
      return <span key={i} className='v-highlight'>{ part }</span>;
    } else {
      return part;
    }
  }

  return <>{parts.map(returnHighlightText)}</>;
}

export const capitalize = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export const usernameStyleStyles = (styles: {
  text_color_start: string;
  text_color_end: string;
  text_gradient_angle: number;
  stroke_color_end: string;
  fontSize?: string;
}) => {
  const text_color_start = styles.text_color_start || '#000000';
  const text_color_end = styles.text_color_end || '#000000';
  const text_gradient_angle = styles.text_gradient_angle || 0;
  const stroke_color_end = styles.stroke_color_end;
  const fontSize = styles.fontSize || "24px";

  return {
    fontFamily: "Ubuntu, sans-serif",
    fontSize: fontSize,
    fontWeight: "600",
    backgroundImage: `linear-gradient(${text_gradient_angle}deg, ${text_color_start}, ${text_color_end})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    WebkitTextStroke: `1px ${stroke_color_end}`,
    letterSpacing: "-0.9px",
  }
}
